import { render, staticRenderFns } from "./pointOld.vue?vue&type=template&id=37168f66&scoped=true&"
import script from "./pointOld.vue?vue&type=script&lang=js&"
export * from "./pointOld.vue?vue&type=script&lang=js&"
import style0 from "./pointOld.vue?vue&type=style&index=0&id=37168f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37168f66",
  null
  
)

component.options.__file = "pointOld.vue"
export default component.exports